/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unused-state */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import CloseIcon from 'Component/CloseIcon';
import Html from 'Component/Html';
import Popup from 'Component/Popup';

import { CookieInfoType, CookieSettingsType } from '../../type/GdprCookie';
import GdprCookieGroupItem from '../GdprCookieGroupItem';
import { GDPR_COOKIES_POPUP_ID } from './GdprCookiePopup.config';

import './GdprCookiePopup.style';

/** @namespace Pwa/Component/GdprCookiePopup/Component/GdprCookiePopupComponent */
export class GdprCookiePopupComponent extends PureComponent {
    static propTypes = {
        cookieGroups: PropTypes.arrayOf(CookieInfoType),
        handleCheckedGroups: PropTypes.func.isRequired,
        handleAcceptAllGroups: PropTypes.func.isRequired,
        handleAcceptCookies: PropTypes.func.isRequired,
        handleDeclineCookies: PropTypes.func.isRequired,
        handleClosePopup: PropTypes.func.isRequired,
        cookieSettings: PropTypes.object,
        isCookieSet: PropTypes.bool,
        isCookieBarActive: PropTypes.bool,
        isStatic: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired
    };

    static defaultProps = {
        cookieGroups: [],
        cookieSettings: [],
        isCookieSet: false,
        isCookieBarActive: false
    };

    state = {
        active_setting: false
    };

    renderCookieGroup = (cookieGroup) => {
        const { handleCheckedGroups } = this.props;
        const {
            groupId,
            isEssential,
            name,
            description,
            cookies
        } = cookieGroup;

        return (
            <GdprCookieGroupItem
              key={ `${groupId}-${name}` }
              groupId={ groupId }
              isEssential={ isEssential }
              name={ name }
              description={ description }
              cookies={ cookies }
              handleCheckedGroups={ handleCheckedGroups }
            />
        );
    };

    renderCookieGroups() {
        const { cookieGroups } = this.props;
        const { active_setting } = this.state;

        if (!active_setting || Object.keys(cookieGroups).length === 0) {
            return null;
        }

        return cookieGroups.reduce(
            (acc, e) => [...acc, this.renderCookieGroup(e)],
            []
        );
    }

    renderDeclineButton() {
        const { handleDeclineCookies } = this.props;
        const { cookieSettings: { gdpr_cookie_decline_enabled } } = this.props;

        if (!gdpr_cookie_decline_enabled) {
            return null;
        }

        return (
            <button
              block="GdprCookiesPopup"
              elem="Decline"
              type="button"
              mix={ { block: 'Button', mods: { isHollow: true } } }
              onClick={ handleDeclineCookies }
            >
                { __('Decline Cookies') }
            </button>
        );
    }

    clickActive=(event) => {
        this.setState({ active_setting: true });
    };

    renderButtons() {
        const {
            handleAcceptAllGroups,
            handleAcceptCookies,
            handleDeclineCookies
        } = this.props;

        const { active_setting } = this.state;
        if (!active_setting) {
            return (
                <div
                  block="GdprCookiesPopup"
                  elem="Buttons"
                >
                   { /* <button
                     block="GdprCookiesPopup"
                     elem="Close"
                     type="button"
                     mix={ { block: 'Button', mods: { isHollow: true } } }
                     onClick={ handleDeclineCookies }
                   >
                        { __('Close') }
                   </button> */ }
                    <button
                      block="GdprCookiesPopup"
                      elem="Setting"
                      type="button"
                      mix={ { block: 'btn', mods: { isHollow: true } } }
                    //   onClick={ () => {
                    //       this.setState({ active_setting: true });
                    //   } }
                      onClick={ () => this.clickActive() }
                    >
                        { __('Cookie Settings') }
                    </button>
                    <button
                      block="GdprCookiesPopup"
                      elem="AllowAll"
                      type="button"
                      mix={ { block: 'Button', mods: { isHollow: true } } }
                      onClick={ handleAcceptAllGroups }
                    >
                    { __('Allow All Cookies') }
                    </button>
                </div>
            );
        }

        return (
            <div
              block="GdprCookiesPopup"
              elem="Buttons"
            >
                { /* <button
                  block="GdprCookiesPopup"
                  elem="Allow"
                  type="button"
                  mix={ { block: 'Button' } }
                  onClick={ handleAcceptCookies }
                >
                    { __('Accept Cookies') }
                </button> */ }
                { /* { this.renderDeclineButton() } */ }
                 <button
                   block="GdprCookiesPopup"
                   elem="AllowAll"
                   type="button"
                   mix={ { block: 'Button', mods: { isHollow: true } } }
                   onClick={ handleAcceptCookies }
                 >
                    { __('Done') }
                 </button>
            </div>
        );
    }

    renderActions() {
        const { cookieSettings: { gdpr_cookie_bar_text } } = this.props;
        const { active_setting = false } = this.state;
        return (
            <div
              block="GdprCookiesPopup"
              elem="Actions"
            >
                { (!active_setting) && (
                    <p
                      block="GdprCookiesPopup"
                      elem="Description"
                    >
                        <Html content={ gdpr_cookie_bar_text } />
                    </p>
                ) }
                { this.renderButtons() }
            </div>
        );
    }

    renderCloseButton() {
        const { handleClosePopup } = this.props;

        return (
            <header block="GdprCookiesPopup" elem="Header">
                <button
                  block="Popup"
                  elem="CloseBtn"
                  aria-label={ __('Close') }
                  onClick={ handleClosePopup }
                >
                    <CloseIcon />
                </button>
            </header>
        );
    }

    renderBasicContent() {
        const {
            isLoading,
            cookieSettings
        } = this.props;

        if (isLoading && !cookieSettings) {
            return null;
        }

        return (
            <div
              block="GdprCookiesPopup"
              elem="Wrapper"
            >
                { this.renderActions() }
            </div>
        );
    }

    renderContent() {
        const {
            isLoading,
            cookieGroups,
            cookieSettings
        } = this.props;

        if (isLoading || !cookieGroups || !cookieSettings) {
            return null;
        }

        return (
            <div
              block="GdprCookiesPopup"
              elem="Wrapper"
            >
                <div
                  block="GdprCookiesPopup"
                  elem="Groups"
                >
                    { this.renderCookieGroups() }
                </div>
                { this.renderActions() }
            </div>
        );
    }

    render() {
        const {
            isCookieSet, isStatic, isCookieBarActive
        } = this.props;

        if (isCookieSet || !isCookieBarActive) {
            return null;
        }

        const baseUrl = window.location.pathname;
        if (baseUrl.includes('checkout/onepage/success') || baseUrl.includes('stripepay/')
            || baseUrl.includes('amazonpay/')) {
            return null;
        }

        const { active_setting = false } = this.state;
        const extraclass = (active_setting) ? '' : ' classic';

        return (
            <Popup
              id={ GDPR_COOKIES_POPUP_ID }
              clickOutside={ false }
              isStatic={ isStatic }
              mix={ { block: `GdprCookiesPopup${ extraclass}` } }
            >
                { /* { this.renderCloseButton() } */ }
                { this.renderContent() }
            </Popup>
        );
    }
}

export default GdprCookiePopupComponent;
